import { backend, websocket } from "@/assets/config/server";
import { io } from "socket.io-client";
import axios from "axios";

const socket = io(websocket);

const api = axios.create({
  baseURL: backend,
});

async function getInbox(page = 1, token, sort = "asc") {
  const response = await api.get("/api/agent/tiket1", {
    params: {
      page,
      sort,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

function cektiket(notiket, indexofalltiket, tiketditandai, listchatdata) {
  var idxtiket = {
    ditandai: null,
    listchat: null,
  };
  if (indexofalltiket != -1) {
    idxtiket["ditandai"] = tiketditandai.findIndex((e) => {
      return e.no_tiket == notiket;
    });

    idxtiket["listchat"] = listchatdata.findIndex((e) => {
      return e.no_tiket == notiket;
    });

    idxtiket["listchat"] =
      idxtiket["listchat"] == -1 ? null : idxtiket["listchat"];
    idxtiket["ditandai"] =
      idxtiket["ditandai"] == -1 ? null : idxtiket["ditandai"];

    if (idxtiket["ditandai"] !== null && idxtiket["listchat"] === null) {
      return {
        indextiket: idxtiket["ditandai"],
        ket: "ditandai",
      };
    } else if (idxtiket["ditandai"] === null && idxtiket["listchat"] !== null) {
      return {
        indextiket: idxtiket["listchat"],
        ket: "listchat",
      };
    } else if (idxtiket["ditandai"] !== null && idxtiket["listchat"] !== null) {
      return {
        indextiket: {
          ditandai: idxtiket["ditandai"],
          listchat: idxtiket["listchat"],
        },
        ket: "both",
      };
    }
  }

  return {
    indextiket: null,
    ket: null,
  };
}

async function carichat(query, token, page = 1) {
  const response = await api.get(`/api/search-chat1`, {
    params: {
      q: query,
      page,
    },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
}

// async function sendMessageBefore(params) {
//   const isthere = (item) => {
//     if (item) {
//       return item;
//     }
//     return null;
//   };
//   const temp = {
//     token: params.token,
//     idtiket: params.idtiket,
//     message: isthere(params.message),
//     image: isthere(params.image),
//     file: isthere(params.file),
//   };

//   var res = null;

//   try {
//     if (temp.message) {
//       if (temp.message == "a") {
//         res = await api.post(
//           `/api/chat/${temp.idtiket}/sen`,
//           {
//             message: temp.message,
//           },
//           {
//             headers: {
//               Accept: "application/json",
//               Authorization: `Bearer ${temp.token}`,
//             },
//           },
//         );
//       } else {
//         res = await api.post(
//           `/api/chat/${temp.idtiket}/send`,
//           {
//             message: temp.message,
//           },
//           {
//             headers: {
//               Accept: "application/json",
//               Authorization: `Bearer ${temp.token}`,
//             },
//           },
//         );
//       }
//     } else if (temp.image) {
//       const formData = new FormData();

//       formData.append("gambar", temp.image);

//       res = await api.post(`/api/chat/${temp.idtiket}/send`, formData, {
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${temp.token}`,
//         },
//       });
//     } else if (temp.file) {
//       const formData = new FormData();

//       formData.append("file", temp.file);

//       res = await api.post(`/api/chat/${temp.idtiket}/send`, formData, {
//         headers: {
//           Accept: "application/json",
//           Authorization: `Bearer ${temp.token}`,
//         },
//       });
//     }

//     return res;
//   } catch (error) {
//     return error;
//   }
// }

async function sendMessage(params) {
    const isthere = (item) => {
        if (item) {
            return item;
        }

        return null;
    };

    const temp = {
        token: params.token,
        idtiket: params.idtiket,
        message: isthere(params.message),
        image: isthere(params.image),
        file: isthere(params.file),
    };

    try {
        // ================= TEXT =================
        if (temp.message) {
            if (temp.message == "a") {
                return await api.post(
                    `/api/chat/${temp.idtiket}/sen`,
                    {
                        message: temp.message,
                    },
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${temp.token}`,
                        },
                    },
                );
            }

            return await api.post(
                `/api/chat/${temp.idtiket}/send`,
                {
                    message: temp.message,
                },
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${temp.token}`,
                    },
                },
            );
        }

        // ================= IMAGE =================
        if (temp.image) {
            const formData = new FormData();

            formData.append("gambar", temp.image);

            return await api.post(
                `/api/chat/${temp.idtiket}/send`,
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${temp.token}`,
                    },
                },
            );
        }

        // ================= PDF =================
        if (temp.file) {
            const formData = new FormData();

            formData.append("file", temp.file);

            return await api.post(
                `/api/chat/${temp.idtiket}/send`,
                formData,
                {
                    headers: {
                        Accept: "application/json",
                        Authorization: `Bearer ${temp.token}`,
                    },
                },
            );
        }

        return null;

    } catch (error) {
        console.error("sendMessage error:", error);
        return error;
    }
}

const formatChatDate = (sent_at) => {
  if (!sent_at) return "";

  const date = new Date(sent_at);

  const today = new Date();

  const isSameDay =
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear();

  // jika hari ini → tampilkan jam
  if (isSameDay) {
    return date.toLocaleTimeString("id-ID", {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  // jika beda hari → tampilkan tanggal
  return date.toLocaleDateString("id-ID", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

function setupdata(params) {
  const tempdata = {
    id: params.id,
    tiket_id: params.tiket_id,
    sender_id: params.sender_id,
    message: params.message,
    sent_at: params.sent_at,
    gambar_pengaduan_thumb: params.gambar_thumb,
    gambar_pengaduan: params.gambar,
    file_pengaduan: params.file,
    sender: {
      id: params.sender_id,
      username: params.username,
      role_id: params.role_id,
      perusahaan: {
        id: params.id_perusahaan,
        users_id: params.user_id,
        nama_perusahaan: params.nama_perusahaan,
      },
    },
  };

  return tempdata;
}

function setupdataraw({
  id,
  msg,
  gambar_thumb,
  gambar,
  file,
  username,
  role_id,
  id_perusahaan,
  user_id,
  nama_perusahaan,
  kodeunik,
}) {
  return {
    id: 1,
    tiket_id: id,
    sender_id: 0,
    kodeunik: kodeunik,
    message: msg,
    sent_at: datetimenow(),

    gambar_thumb,
    gambar,
    file,

    username,
    role_id,

    id_perusahaan,
    user_id,

    nama_perusahaan,
  };
}

function datetimenow() {
  const now = new Date();

  const datetime = now
    .toLocaleString("sv-SE", {
      timeZone: "Asia/Jakarta",
    })
    .replace("T", " ");

  return datetime;
}

function kirimchatsocket({
  id,
  role_id,
  username,
  message,
  file,
  img,
  no_tiket,
  tiket_id,
  wholetiket,
}) {
  const kirim = socket.emit("balasMessage", {
    id: id,
    sender: {
      role_id: role_id,
      username: username,
    },
    type: 1,
    message: message,
    date: datetimenow(),
    time: datetimenow(),
    file_pengaduan: file,
    gambar_pengaduan: img,
    senderType: "agent",
    no_tiket: no_tiket,
    tiket_id: tiket_id,
    wholetiket: wholetiket,
  });

  return kirim;
}

function generateUniqueId(length = 16) {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  return Array.from(crypto.getRandomValues(new Uint8Array(length)))
    .map((x) => chars[x % chars.length])
    .join("");
}

async function batalkirimchat(idtiket, userid, msg, token) {
  const res = await api.post(
    `/api/chat/batalkirim`,
    {
      idtiket: idtiket,
      userid: userid,
      msg: msg,
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return res;
}

export {
  getInbox,
  formatChatDate,
  setupdata,
  sendMessage,
  setupdataraw,
  datetimenow,
  kirimchatsocket,
  generateUniqueId,
  cektiket,
  carichat,
  batalkirimchat,
};
